export default "__VITE_ASSET__76cd52d5__"